import { render, staticRenderFns } from "./stepFecharRemessa.vue?vue&type=template&id=66ab8f20"
import script from "./stepFecharRemessa.vue?vue&type=script&lang=ts"
export * from "./stepFecharRemessa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports